module.exports = __webpack_public_path__ + "media/country_flags/gu-965b058d.png";